import { useAuthStore } from "~/common/stores/AuthStore";
export default defineNuxtPlugin(() => {
  return {
    provide: {
      auth: useAuthStore(),
    },
  };
});
